//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    KEYSFOBS_GET_KEYFOB_REQUEST,
    KEYSFOBS_CREATE_REQUEST,
    KEYSFOBS_UPDATE_REQUEST,
    KEYSFOBS_GET_DRIVER_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    keyfobsGetDriversResult,
    keyfobsCreateResult,
    keyfobsGetKeyFobResult,
    keyfobsUpdateResult,
} from 'Redux/actions';

function* getKeyFob({ payload }) {
    try {
        let QUERY = `
            query getKeyFob ($id: Int!) {
                result: getKeyFob (id: $id) {
                    id
                    companyId
                    hex
                    driverId
                    driver {
                        id
                        name
                    }
                    company {
                        id
                        dealerId
                        name
                        status
                    }
                    keyFobModel {
                        id
                        name
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(keyfobsGetKeyFobResult(data.result))

    } catch (exc) {
        yield put(keyfobsGetKeyFobResult())
        ExceptionManager(exc, 'Modules/keysFobs/.components/createEditKeyFob/redux/saga', 'getKeyFob');
    }
}

function* createKeyFob({ payload }) {
    try {
        let QUERY = `
            mutation createKeyFob ($companyId: Int!, $hex: String!, $driverId: Int!, $keyFobModelId: Int!) {
                result: createKeyFob (companyId: $companyId, hex: $hex, driverId: $driverId, keyFobModelId: $keyFobModelId) {
                    id
                    companyId
                    hex
                    driverId
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(keyfobsCreateResult(data?.result))
        } else yield put(keyfobsCreateResult())

    } catch (exc) {
        yield put(keyfobsCreateResult({ error: exc }))
        ExceptionManager(exc, 'Modules/keysFobs/.components/createEditKeyFob/redux/saga', 'createKeyFob');
    }
}

function* updateKeyFob({ payload }) {
    try {
        let QUERY = `
            mutation updateKeyFob ($id: Int!, $companyId: Int, $hex: String, $driverId: Int, $keyFobModelId: Int!) {
                result: updateKeyFob (id: $id, companyId: $companyId, hex: $hex, driverId: $driverId, keyFobModelId: $keyFobModelId) {
                    id
                    companyId
                    hex
                    driverId
                    driver {
                        id
                        name
                    }
                    company {
                        id
                        dealerId
                        name
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(keyfobsUpdateResult(data?.result));

    } catch (exc) {
        yield put(keyfobsUpdateResult({ error: exc }));
        ExceptionManager(exc, 'Modules/keysFobs/.components/createEditKeyFob/redux/saga', 'updateKeyFob');
    }
}

function* searchDrivers({ payload }) {
    try {
        let QUERY = `
            query searchDrivers ($conditions: [DriverSearchInput], $sort: [DriverSortInput], $limit: Int, $offset: Int) {
                result: searchDrivers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                        companyId
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["company_name"],
                    terms: [payload],
                    exact: true
                },
                limit: 100,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(keyfobsGetDriversResult(items))
        } else yield put(keyfobsGetDriversResult([]))

    } catch (exc) {
        yield put(keyfobsGetDriversResult([]))
        ExceptionManager(exc, 'Modules/keysFobs/.components/createEditKeyFob/redux/saga', 'searchDrivers');
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'getAccounts');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(KEYSFOBS_GET_KEYFOB_REQUEST, getKeyFob);
    yield takeEvery(KEYSFOBS_CREATE_REQUEST, createKeyFob);
    yield takeEvery(KEYSFOBS_UPDATE_REQUEST, updateKeyFob);
    yield takeEvery(KEYSFOBS_GET_DRIVER_REQUEST, searchDrivers);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}